import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { Modal, Box, Typography, Button } from "@mui/material";
import log from "../resources/Logo.svg";
import Footerlogo from "../resources/pollicydekhoo-Cdr-jpg-300x300 1 (1).png";
import Callsupport from "../resources/callsupport.svg";
import Callback from "../resources/callbacksupport.svg";
import Whatupsupport from "../resources/whatupsupport.svg";
import Mailsupport from "../resources/mailsupport.svg";
import "./EMIForm.css";

function EMIForm() {
  const [language, setLanguage] = useState("en");
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    mobileNumber: "",
    vehicleRegNumber: "",
    expiryDate: "",
    claimStatus: "",
    ncb: "",
    occupation: "",
    monthlyIncome: "",
    panNumber: "",
    aadharNumber: ""
  });

  const navigate = useNavigate();
  const contactFormRef = useRef(null);

  // Modal style
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleNumericInput = (e) => {
    const { name, value } = e.target;
    if (/^\d*$/.test(value)) {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === "en" ? "hi" : "en");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!formData.name || !formData.mobileNumber || !formData.vehicleRegNumber) {
      return;
    }

    try {
      const response = await fetch('https://policydekhoo-backend.onrender.com/SetEMIFormData', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          mobile_number: formData.mobileNumber,
          vehicle_reg_number: formData.vehicleRegNumber,
          expiry_date: formData.expiryDate || null,
          claim_status: formData.claimStatus || '',
          ncb: formData.ncb || '',
          occupation: formData.occupation || '',
          monthly_income: formData.monthlyIncome ? parseFloat(formData.monthlyIncome) : null,
          pan_number: formData.panNumber || '',
          aadhar_number: formData.aadharNumber || ''
        })
      });

      const data = await response.json();
      
      if (response.ok) {
        // Reset form on successful submission
        setFormData({
          name: "",
          mobileNumber: "",
          vehicleRegNumber: "",
          expiryDate: "",
          claimStatus: "",
          ncb: "",
          occupation: "",
          monthlyIncome: "",
          panNumber: "",
          aadharNumber: ""
        });
        
        console.log('Form submitted successfully:', data);
      } else {
        throw new Error(data.error || 'Failed to submit form');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  const navigateTo = (path) => {
    navigate(path);
  };

  // Generate years for dropdown
  const years = [];
  const currentYear = new Date().getFullYear();
  for (let year = currentYear; year >= 2000; year--) {
    years.push(year);
  }

  return (
    <div>
      <div className="container-fluid mb-5">
        <div className="row align-items-center">
          {/* Logo Section */}
          <div
            className="col-8 col-lg-3 mt-3 ps-5 d-flex align-items-center"
            onClick={() => navigateTo("/")}
            style={{ cursor: "pointer" }}
          >
            <img
              src={log}
              alt="Logo"
              style={{ width: "12vw", maxWidth: "50px" }}
            />
            <span className="fs-5 ms-2">Policy Dekhoo</span>
          </div>

          {/* Navigation Links */}
          <div className="col-lg-7 col-4 d-flex justify-content-end align-items-center">
            <div className="row align-items-center w-100">
              <div className="col-lg-9 d-none d-lg-block">
                <ul className="list-inline mb-0">
                  <li className="list-inline-item p-2">Home</li>
                  <li className="list-inline-item p-2">PD Advantages</li>
                  <li className="list-inline-item p-2">Customer Rating</li>
                  <li className="list-inline-item p-2" onClick={() => navigateTo("/About")}>
                    About Us
                  </li>
                  <li className="list-inline-item p-2 dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                    >
                      Support
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown"
                      style={{ minWidth: "200px" }}
                    >
                      <li>
                        <a className="dropdown-item" href="#">
                          <img src={Callsupport} className="me-2" alt="" />
                          Call Us
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="mailto:info@policydekhoo.com"
                        >
                          <img
                            src={Mailsupport}
                            className="me-2"
                            alt="Mail Support"
                          />
                          Mail Us
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="https://wa.me/lokesh"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={Whatupsupport}
                            className="me-2"
                            alt="WhatsApp Support"
                          />
                          WhatsApp
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleOpen();
                          }}
                        >
                          <img
                            src={Callback}
                            className="me-2"
                            alt="Callback Icon"
                          />
                          Call Back
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="list-inline-item p-2" onClick={() => navigateTo("/Claim")}>
                    Claim
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 text-end">
                <button
                  className="btn btn-outline-primary"
                  onClick={toggleLanguage}
                >
                  {language === "en" ? "हिंदी" : "English"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="w-75 mx-auto text-center mb-5">
              <h1 className="fw-bold mb-4">
                {language === "en"
                  ? "Get Your EMI Details"
                  : "अपना EMI विवरण प्राप्त करें"}
              </h1>
              <p className="fs-5 text-muted">
                {language === "en"
                  ? "Fill in the details below to get your personalized EMI options"
                  : "अपने व्यक्तिगत EMI विकल्प प्राप्त करने के लिए नीचे विवरण भरें"}
              </p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-10">
            <div className="card shadow-sm p-4 mb-5 bg-white rounded">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    {/* Name Field */}
                    <div className="col-md-6 mb-4">
                      <label htmlFor="name" className="form-label fw-bold">
                        {language === "en" ? "Full Name" : "पूरा नाम"}
                      </label>
                      <input
                        type="text"
                        className="form-control p-3"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        placeholder={language === "en" ? "Enter your full name" : "अपना पूरा नाम दर्ज करें"}
                      />
                    </div>

                    {/* Mobile Number */}
                    <div className="col-md-6 mb-4">
                      <label htmlFor="mobileNumber" className="form-label fw-bold">
                        {language === "en" ? "Mobile Number" : "मोबाइल नंबर"}
                      </label>
                      <input
                        type="tel"
                        className="form-control p-3"
                        id="mobileNumber"
                        name="mobileNumber"
                        value={formData.mobileNumber}
                        onChange={handleNumericInput}
                        maxLength="10"
                        required
                        placeholder={language === "en" ? "Enter 10-digit mobile number" : "10 अंकों का मोबाइल नंबर दर्ज करें"}
                      />
                    </div>

                    {/* Vehicle Registration Number */}
                    <div className="col-md-6 mb-4">
                      <label htmlFor="vehicleRegNumber" className="form-label fw-bold">
                        {language === "en" ? "Vehicle Registration No." : "वाहन पंजीकरण संख्या"}
                      </label>
                      <input
                        type="text"
                        className="form-control p-3 text-uppercase"
                        id="vehicleRegNumber"
                        name="vehicleRegNumber"
                        value={formData.vehicleRegNumber}
                        onChange={handleInputChange}
                        required
                        placeholder={language === "en" ? "E.g., MH01AB1234" : "जैसे, MH01AB1234"}
                      />
                    </div>

                    {/* Expiry Date */}
                    <div className="col-md-6 mb-4">
                      <label htmlFor="expiryDate" className="form-label fw-bold">
                        {language === "en" ? "Expiry Date" : "समाप्ति तिथि"}
                      </label>
                      <input
                        type="date"
                        className="form-control p-3"
                        id="expiryDate"
                        name="expiryDate"
                        value={formData.expiryDate}
                        onChange={handleInputChange}
                        required
                      />
                    </div>

                    {/* Claim Status */}
                    <div className="col-md-6 mb-4">
                      <label htmlFor="claimStatus" className="form-label fw-bold">
                        {language === "en" ? "Claim Status" : "दावा स्थिति"}
                      </label>
                      <select
                        className="form-select p-3"
                        id="claimStatus"
                        name="claimStatus"
                        value={formData.claimStatus}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">{language === "en" ? "Select Claim Status" : "दावा स्थिति चुनें"}</option>
                        <option value="No Claim">{language === "en" ? "No Claim" : "कोई दावा नहीं"}</option>
                        <option value="Claimed">{language === "en" ? "Claimed" : "दावा किया गया"}</option>
                      </select>
                    </div>

                    {/* NCB */}
                    <div className="col-md-6 mb-4">
                      <label htmlFor="ncb" className="form-label fw-bold">
                        {language === "en" ? "NCB %" : "एनसीबी %"}
                      </label>
                      <select
                        className="form-select p-3"
                        id="ncb"
                        name="ncb"
                        value={formData.ncb}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">{language === "en" ? "Select NCB %" : "एनसीबी % चुनें"}</option>
                        <option value="20">20%</option>
                        <option value="25">25%</option>
                        <option value="35">35%</option>
                        <option value="45">45%</option>
                        <option value="50">50%</option>
                        <option value="65">65%</option>
                      </select>
                    </div>

                    {/* Occupation */}
                    <div className="col-md-6 mb-4">
                      <label htmlFor="occupation" className="form-label fw-bold">
                        {language === "en" ? "Occupation" : "व्यवसाय"}
                      </label>
                      <select
                        className="form-select p-3"
                        id="occupation"
                        name="occupation"
                        value={formData.occupation}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">{language === "en" ? "Select Occupation" : "व्यवसाय चुनें"}</option>
                        <option value="Salaried">{language === "en" ? "Salaried" : "वेतनभोगी"}</option>
                        <option value="Self-Employed">{language === "en" ? "Self-Employed" : "स्वरोजगार"}</option>
                        <option value="Business">{language === "en" ? "Business" : "व्यवसाय"}</option>
                        <option value="Professional">{language === "en" ? "Professional" : "पेशेवर"}</option>
                        <option value="Other">{language === "en" ? "Other" : "अन्य"}</option>
                      </select>
                    </div>

                    {/* Monthly Income */}
                    <div className="col-md-6 mb-4">
                      <label htmlFor="monthlyIncome" className="form-label fw-bold">
                        {language === "en" ? "Monthly Income (₹)" : "मासिक आय (₹)"}
                      </label>
                      <input
                        type="text"
                        className="form-control p-3"
                        id="monthlyIncome"
                        name="monthlyIncome"
                        value={formData.monthlyIncome}
                        onChange={handleNumericInput}
                        required
                        placeholder={language === "en" ? "Enter monthly income" : "मासिक आय दर्ज करें"}
                      />
                    </div>

                    {/* PAN Number */}
                    <div className="col-md-6 mb-4">
                      <label htmlFor="panNumber" className="form-label fw-bold">
                        {language === "en" ? "PAN No." : "पैन नंबर"}
                      </label>
                      <input
                        type="text"
                        className="form-control p-3 text-uppercase"
                        id="panNumber"
                        name="panNumber"
                        value={formData.panNumber}
                        onChange={(e) => {
                          const value = e.target.value.toUpperCase();
                          if (/^[A-Z0-9]{0,10}$/.test(value)) {
                            setFormData(prev => ({
                              ...prev,
                              panNumber: value
                            }));
                          }
                        }}
                        maxLength="10"
                        required
                        placeholder={language === "en" ? "E.g., ABCDE1234F" : "जैसे, ABCDE1234F"}
                      />
                    </div>

                    {/* Aadhar Number */}
                    <div className="col-md-6 mb-4">
                      <label htmlFor="aadharNumber" className="form-label fw-bold">
                        {language === "en" ? "Aadhaar No." : "आधार नंबर"}
                      </label>
                      <input
                        type="text"
                        className="form-control p-3"
                        id="aadharNumber"
                        name="aadharNumber"
                        value={formData.aadharNumber}
                        onChange={handleNumericInput}
                        maxLength="12"
                        required
                        placeholder={language === "en" ? "Enter 12-digit Aadhaar number" : "12 अंकों का आधार नंबर दर्ज करें"}
                      />
                    </div>

                    {/* Submit Button */}
                    <div className="col-12 text-center mt-4">
                      <button type="submit" className="btn btn-primary btn-lg px-5 py-3">
                        {language === "en" ? "Get EMI Options" : "EMI विकल्प प्राप्त करें"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Callback Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2" className="mb-4">
            {language === "en" ? "Request a Call Back" : "कॉल बैक का अनुरोध करें"}
          </Typography>
          <form>
            <div className="mb-3">
              <label htmlFor="phone" className="form-label">
                {language === "en" ? "Phone Number" : "फोन नंबर"}
              </label>
              <input
                type="tel"
                className="form-control"
                id="phone"
                required
                placeholder={language === "en" ? "Enter your phone number" : "अपना फोन नंबर दर्ज करें"}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="reason" className="form-label">
                {language === "en" ? "Reason for Call Back" : "कॉल बैक का कारण"}
              </label>
              <textarea
                className="form-control"
                id="reason"
                rows="3"
                required
                placeholder={language === "en" ? "Briefly describe the reason for the call back" : "कॉल बैक का कारण संक्षेप में बताएं"}
              ></textarea>
            </div>
            <div className="d-flex justify-content-end gap-2">
              <Button variant="outlined" onClick={handleClose} className="me-2">
                {language === "en" ? "Cancel" : "रद्द करें"}
              </Button>
              <Button variant="contained" type="submit">
                {language === "en" ? "Request Call" : "कॉल का अनुरोध करें"}
              </Button>
            </div>
          </form>
        </Box>
      </Modal>

      {/* Footer */}
      <footer className="container-fluid mt-5" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="container py-5">
          <div className="row">
            <div className="col-md-4 mb-4">
              <h5 className="mb-3">About Policy Dekhoo</h5>
              <p>
                {language === "en"
                  ? "Your trusted partner for all insurance needs. We provide the best insurance solutions tailored to your requirements."
                  : "आपकी सभी बीमा आवश्यकताओं के लिए विश्वसनीय साथी। हम आपकी आवश्यकताओं के अनुरूप सर्वोत्तम बीमा समाधान प्रदान करते हैं।"}
              </p>
            </div>
            <div className="col-md-4 mb-4">
              <h5 className="mb-3">Quick Links</h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a href="#!" className="text-decoration-none text-dark">Home</a>
                </li>
                <li className="mb-2">
                  <a href="#!" className="text-decoration-none text-dark">About Us</a>
                </li>
                <li className="mb-2">
                  <a href="#!" className="text-decoration-none text-dark">Contact</a>
                </li>
                <li className="mb-2">
                  <a href="#!" className="text-decoration-none text-dark">Privacy Policy</a>
                </li>
              </ul>
            </div>
            <div className="col-md-4 mb-4">
              <h5 className="mb-3">Contact Us</h5>
              <p>
                <i className="bi bi-geo-alt-fill me-2"></i> 123 Insurance Street, Mumbai, India
              </p>
              <p>
                <i className="bi bi-telephone-fill me-2"></i> +91 98765 43210
              </p>
              <p>
                <i className="bi bi-envelope-fill me-2"></i> info@policydekhoo.com
              </p>
            </div>
          </div>
          <hr className="my-4" />
          <div className="text-center">
            <p className="mb-0">
              &copy; {new Date().getFullYear()} Policy Dekhoo. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default EMIForm;